/**
 * @flow
 * @relayHash 7061a7415f40d20f988071bd1f3386d0
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DendrogramContainer_QueryVariables = {||};
export type DendrogramContainer_QueryResponse = {|
  +elements: ?$ReadOnlyArray<?{|
    +name: string,
    +id: string,
    +__typename: string,
    +children: ?$ReadOnlyArray<?{|
      +name: string,
      +id: string,
      +__typename: string,
      +children: ?$ReadOnlyArray<?{|
        +name: string,
        +id: string,
        +__typename: string,
      |}>,
    |}>,
  |}>
|};
*/


/*
query DendrogramContainer_Query {
  elements {
    name
    id
    __typename
    children {
      name
      id
      __typename
      children {
        name
        id
        __typename
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v3 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "elements",
    "storageKey": null,
    "args": null,
    "concreteType": "Element",
    "plural": true,
    "selections": [
      v0,
      v1,
      v2,
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "children",
        "storageKey": null,
        "args": null,
        "concreteType": "Theme",
        "plural": true,
        "selections": [
          v0,
          v1,
          v2,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "children",
            "storageKey": null,
            "args": null,
            "concreteType": "Principle",
            "plural": true,
            "selections": [
              v0,
              v1,
              v2
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "DendrogramContainer_Query",
  "id": null,
  "text": "query DendrogramContainer_Query {\n  elements {\n    name\n    id\n    __typename\n    children {\n      name\n      id\n      __typename\n      children {\n        name\n        id\n        __typename\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "DendrogramContainer_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": v3
  },
  "operation": {
    "kind": "Operation",
    "name": "DendrogramContainer_Query",
    "argumentDefinitions": [],
    "selections": v3
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '42a07f649d8c5eec3afa27e5f234d437';
module.exports = node;



// WEBPACK FOOTER //
// ./src/Components/DendrogramContainer/__generated__/DendrogramContainer_Query.graphql.js